// src/components/Header.jsx

import { Link } from 'react-router-dom';
import { useAuth0 } from '@/hooks/useAuth';
import { MainMenu } from './MainMenu';
import { UserMenu } from './UserMenu';
import { BrandLoader } from './BrandLoader';

export function Header() {
  const { isAuthenticated, isLoading } = useAuth0();

  return (
    <header className="sticky top-0 z-40 w-full border-b border-gray-200 bg-white/80 backdrop-blur-sm dark:border-gray-800 dark:bg-gray-900/80">
      <div className="container mx-auto flex h-16 items-center justify-between px-4">
        {/* Coluna da Esquerda (Placeholder) */}
        <div className="w-16 flex items-center justify-start">
          {isLoading && <BrandLoader size={32} />}
          {isAuthenticated && <UserMenu />}
        </div>

        {/* Coluna Central (Título) */}
        <div className="flex-1 text-center md:text-left"> {/* Ajuste para alinhar à esquerda em telas maiores */}
          <Link
            to="/"
            className="text-xl font-bold text-gray-900 dark:text-white"
          >
            O Porteiro
          </Link>
        </div>

        {/* --- LÓGICA CORRIGIDA NA COLUNA DA DIREITA --- */}
        {/* Este div agora é um contêiner flex para acomodar ambos os menus */}
        <div className="flex items-center justify-end gap-4">
          {/* 1. O MainMenu (navegação) é renderizado SEMPRE */}
          <MainMenu />
        </div>
      </div>
    </header>
  );
}
